import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import useTranslation from "../../mlang/useTranslation"
import withLayout from "../../components/layout/withLayout"
import SEO from "../../components/seo"
import HeaderEquip from "../../components/equipment/headerEquip"
import LaserEquip from "../../components/equipment/laserEquip"
import EquipTable from "../../components/equipment/equipTable"
import Positioner from "../../components/equipment/positioner"
import EquipList from "../../components/equipment/equipList"
import CutSpeedsBtn from "../../components/equipment/cut-speeds-btn"
import Samples from "../../components/equipment/samples"

const InfracutCub = () => {
  const equip = useTranslation("infracut-cub")

  const {
    file: { image },
    allFile: { images },
    more: { samples },
  } = useStaticQuery(graphql`
    {
      file(relativeDirectory: { eq: "cutting" }, name: { eq: "infracut-cub" }) {
        image: childImageSharp {
          fluid(quality: 100) {
            ...GatsbyImageSharpFluid
          }
        }
      }
      allFile(
        filter: {
          relativeDirectory: { eq: "equipment" }
          name: { regex: "/laserEquip/" }
        }
      ) {
        images: nodes {
          image: childImageSharp {
            fluid(quality: 100) {
              originalName
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      more: allFile(filter: { name: { regex: "/infracut-\\\\d$/" } }) {
        samples: nodes {
          image: childImageSharp {
            fluid(quality: 100) {
              originalName
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  `)

  return (
    <div className="page">
      <SEO {...equip.seo} purpose={equip.purpose} />
      <HeaderEquip equip={equip} image={image} />
      <LaserEquip equip={equip["laser-equipment"]} images={images} />
      <EquipTable data={equip.specifications} />
      <Positioner data={equip.positioner} />
      <EquipList data={equip.supplied} />
      <Samples images={samples} />
      <CutSpeedsBtn />
    </div>
  )
}

export default withLayout(InfracutCub)
